import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/pages/Main'
import Art from '@/pages/Art'
import Business from '@/pages/Business'
import Career from '@/pages/Career'
import Family from '@/pages/Family'
import Sport from '@/pages/Sport'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'main',
			component: Main,
		},
		{
			path: '/art',
			name: 'art',
			component: Art,
		},
		{
			path: '/business',
			name: 'business',
			component: Business,
		},
		{
			path: '/career',
			name: 'career',
			component: Career,
		},
		{
			path: '/family',
			name: 'family',
			component: Family,
		},
		{
			path: '/sport',
			name: 'sport',
			component: Sport,
		},
	],
})
